import type { PdfPerson } from '@makemydeal/dr-platform-types';
import { CUSTOMER_CONTACT_SEPARATOR } from '../constants';
import type { ProposalCustomerInfo } from '../types';
import { joinNonEmpty } from './proposalUtils';

export const mapSalesPersonName = (salesPerson?: PdfPerson): string =>
    joinNonEmpty([salesPerson?.firstName, salesPerson?.lastName]);

export const mapCustomer = (buyer: PdfPerson, coBuyerName?: string): ProposalCustomerInfo => {
    const contactInfo = joinNonEmpty(
        [buyer.email, buyer.phone, joinNonEmpty([buyer.streetAddress, buyer.city, joinNonEmpty([buyer.state, buyer.zip])], ', ')],
        CUSTOMER_CONTACT_SEPARATOR
    );
    return {
        customerName: joinNonEmpty([buyer.firstName, buyer.lastName]),
        ...(coBuyerName && { coBuyerName }),
        ...(contactInfo && { contactInfo })
    };
};
